import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardFilterBridgeComponent } from './dashboard-filter-bridge.component';

@NgModule({
  imports: [CommonModule],
  declarations: [DashboardFilterBridgeComponent],
  exports: [DashboardFilterBridgeComponent],
})
export class FilterPanelModule {}
